module.exports = __webpack_public_path__ + "img/atlas-logo.6a942a06.png";